import styled, { keyframes } from 'styled-components';
import { baseTheme } from '../../../../../../global/styles/theme';

const slidein = keyframes`
  0%   { color: var(--bg); border-color: var(--bg); }
  50%  { color: transparent; border-color: transparent; }
  100% { color: var(--bg); border-color: var(--bg); }
`;

export const PaymentIndicatorContainer = styled('div')`
  position: relative;
  width: 100%;
  pointer-events: none;

  & .indicator {
    width: 115px;
    height: 115px;
    position: absolute;
    bottom: -44px;
    right: 160px;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    animation: ${slidein} 1.2s ease-in-out infinite;
    border: 4px solid var(--bg);
    color: var(--bg);
    text-align: center;
  }

  & .indicator.paid {
    --bg: ${() => baseTheme.colors.focus};
  }

  & .indicator.not-paid {
    --bg: ${() => baseTheme.colors.error};
  }
`;
